import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { readJson, STORAGE_KEYS } from './storage';

export type RevenueUnit = 'MRR' | 'ARR';

/** Profile preferences: defaults for the global filters and notification switches. */
export interface PrefsState {
  unit: RevenueUnit;
  range: 3 | 6 | 12 | 24;
  digest: boolean;
  renewalAlerts: boolean;
}

export const DEFAULT_PREFS: PrefsState = {
  unit: 'MRR',
  range: 12,
  digest: true,
  renewalAlerts: true,
};

export const loadPrefs = (): PrefsState => readJson(STORAGE_KEYS.prefs, DEFAULT_PREFS);

export const prefsSlice = createSlice({
  name: 'prefs',
  initialState: DEFAULT_PREFS,
  reducers: {
    prefsChanged(state, action: PayloadAction<Partial<PrefsState>>) {
      Object.assign(state, action.payload);
    },
  },
  selectors: {
    selectPrefs: (state) => state,
  },
});

export const { prefsChanged } = prefsSlice.actions;
export const { selectPrefs } = prefsSlice.selectors;
